import React from 'react';
import css from './LandingPage.css';
import bgImg from './bgCZ.jpg';
import Promo10 from './pt10.png';
import Promo25 from './pt25.png';
import Promo25Bikes from './promo25bikes.png';
import Promo50 from './pt50.png';
import { NamedLink } from '../../components';

const tiles = [
  {
    img: Promo25,
    title: 'Letnia promocja! Wypożycz SUP-a na min. 2 dni i zyskaj -25% z kodem "WODA25"',
    linkName: 'WatersportsSupSearchPage',
  },
  {
    img: Promo25Bikes,
    title: 'Jesienna promocja! Wypożycz rower na min. 3 dni i zyskaj -25% z kodem "ROWER25"',
    externalLink: 'https://rent.decathlon.pl/s?keywords=rower',
  }, 
  {
    img: Promo50,
    title: 'Im dłużej wypożyczasz, tym więcej zyskujesz!',
    externalLink: 'https://prod-rent-backend-a9sd29me0v9sv.s3.eu-west-1.amazonaws.com/prod/doc/pl/wypozyczasz-na-dluzej-zyskujesz-wiecej.pdf',
  },
];

const PromoTiles = () => (
  <div className={css.promoTilesSectionWrapper}>
    <div className={css.promoTilesWrapper}>
      {tiles.map((tile, idx) => {
        const TileContent = (
          <>
            <div className={css.promoTileImgWrapper}>
              <img src={tile.img} alt={tile.title} className={css.promoTileImg} />
            </div>
            <div className={css.promoTileBottom}>
              <div className={css.promoTileText}>{tile.title}</div>
              <div className={css.promoTileBtn}>Sprawdź</div>
            </div>
          </>
        );
        if (tile.linkName) {
          return (
            <NamedLink className={css.promoTile} name={tile.linkName} key={idx}>
              {TileContent}
            </NamedLink>
          );
        }
        if (tile.externalLink) {
          return (
            <a
              className={css.promoTile}
              href={tile.externalLink}
              target="_blank"
              // rel="noopener noreferrer"
              key={idx}
            >
              {TileContent}
            </a>
          );
        }
        return (
          <div className={css.promoTile} key={idx}>
            {TileContent}
          </div>
        );
      })}
    </div>
  </div>
);

export default PromoTiles; 